import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnInit,
	QueryList,
	ViewChild,
	ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
	catchError,
	map,
	startWith,
	tap,
} from 'rxjs/operators';

import { Observable, of } from 'rxjs';

import { HttpRequestResult } from 'ib/internetbank-core/utils/http-client.utils';


import { NotificationStickerService } from '../../../pages/layout/header/components/notification-sticker/notification-sticker.service';
import { AppealsComponentRouterParameters } from '../../../pages/profile/pages/appeals-2/appeals/appeals.component';
import { AppealItemComponent } from '../appeal-item/appeal-item.component';
import { Appeal } from '../statements-model';
import { StatementsService } from '../statements.service';

@Component({
	selector: 'app-appeal-block',
	templateUrl: './appeal-block.component.html',
	styleUrls: ['./appeal-block.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AppealBlockComponent implements OnInit, AfterViewInit {

	@ViewChild('statementsHeader')
	public statementsHeaderElement: ElementRef<HTMLElement>;

	@ViewChildren(AppealItemComponent)
	public appealItemComponent: QueryList<AppealItemComponent>;

	@Input()
	public title: string;

	public routerParameters: AppealsComponentRouterParameters = { regNumber: this.activatedRoute.snapshot.params.regNumber };

	public appeals$: Observable<HttpRequestResult<Array<Appeal> | undefined>> = this.statementsService.getAppeals()
		.pipe(
			map((data: Array<Appeal>) => {
				return HttpRequestResult.sucess(data)
			}),
			catchError(() => {
				return of(HttpRequestResult.error('Ошибка загрузки данных'));
			}),
		);

	constructor(
		private statementsService: StatementsService,
		private changeDetectorRef: ChangeDetectorRef,
		private notificationStickerService: NotificationStickerService,
		private activatedRoute: ActivatedRoute,
	) { }

	public ngOnInit(): void {

	}
	public ngAfterViewInit(): void {

		this.appealItemComponent.changes
			.pipe(
				startWith(this.appealItemComponent),
				tap(() => {

					if (this.routerParameters.regNumber) {
						setTimeout(() => {
							this.scrollToApeal(this.routerParameters.regNumber);
							this.highlightApeal(this.routerParameters.regNumber);
						}, 0);

					}
				}),
			)
			.subscribe();
	}

	public viewedAppeal(options: {
		regNumber: string;
		status: string | undefined
	}): void {
		this.statementsService.viewedAppeal(options.regNumber, options.status)
			.subscribe();

		this.notificationStickerService.updateStickerForStatements(options.regNumber);
	}

	public scrollToApeal(regNumber: string): void {

		const element: HTMLElement | null = document.getElementById('statements__item' + regNumber);
		element?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});

	}

	public highlightApeal(regNumber: string): void {

		setTimeout(() => {

			const element: HTMLElement | null = document.getElementById('statements__item' + regNumber);
			element?.classList.add('statements__item--highlighted');

			setTimeout(() => {
				element?.classList.remove('statements__item--highlighted');
			}, 1500);

		}, 1000);
	}

}
